import pathToRegexp from 'path-to-regexp';

import { REFERENCES, REFERENCED_BY } from 'constant/chainscript';
import { ROUTE_INSPECT_TRACE, ROUTE_WORKFLOW_OVERVIEW } from 'constant/routes';
import { ReferenceLink } from '../references.types';

type Props = {
  link: ReferenceLink;
  traceId: string;
  workflowId: string;
  refCount: number;
  referenceType: typeof REFERENCES | typeof REFERENCED_BY;
};

export const Reference = ({
  link,
  traceId,
  refCount,
  workflowId,
  referenceType
}: Props) => {
  const hrefTrace = `${pathToRegexp.compile(ROUTE_INSPECT_TRACE)({
    id: link.traceId
  })}`;

  const hrefTraceWithLink = link.linkHash
    ? `${hrefTrace}/${link.linkHash}`
    : hrefTrace;

  const hrefWorkflow = `${pathToRegexp.compile(ROUTE_WORKFLOW_OVERVIEW)({
    id: link.workflow.rowId
  })}`;

  if (link.traceId === traceId) {
    return (
      <span className="text-muted-foreground text-sm">
        {getPrefix(refCount, referenceType)}{' '}
        <StyledLink href={hrefTraceWithLink}>{link.action.title}</StyledLink> of
        this Trace.
      </span>
    );
  }

  if (link.workflow.rowId === workflowId) {
    return (
      <span className="text-muted-foreground text-sm">
        {getPrefix(refCount, referenceType)}{' '}
        <StyledLink href={hrefTraceWithLink}>{link.action.title}</StyledLink> in
        the Trace <StyledLink href={hrefTrace}>{link.trace.name}</StyledLink> in
        this workflow.
      </span>
    );
  }

  return (
    <span className="text-muted-foreground text-sm">
      {getPrefix(refCount, referenceType)}{' '}
      <StyledLink href={hrefTraceWithLink}>{link.action.title}</StyledLink> in
      the Trace <StyledLink href={hrefTrace}>{link.trace.name}</StyledLink> of
      the <StyledLink href={hrefWorkflow}>{link.workflow.name}</StyledLink>{' '}
      workflow.
    </span>
  );
};

const getPrefix = (
  refCount: Props['refCount'],
  referenceType: Props['referenceType']
) => {
  let prefixText = '';
  if (refCount === 1) prefixText += 'this action ';

  prefixText +=
    referenceType === REFERENCES ? 'references' : 'is referenced by';
  return prefixText.charAt(0).toUpperCase() + prefixText.slice(1);
};

const StyledLink = ({
  href,
  children
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="text-primary no-underline hover:underline"
  >
    {children}
  </a>
);
